import {v4 as uuidv4} from "uuid";
import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlan} from "../view-model";
import {toOperationalEntityInput} from "./toOperationalEntityInput";

/**
 * This function transforms a {@link ClientEntity} into the {@link CreatePlan}
 * view model.
 *
 * Note that this function does not apply business rules during transformation;
 * it is only responsible for transforming the API model to the view model.
 *
 * @param source
 */
export const toCreatePlan = (source: ClientEntity): CreatePlan => ({
  source,
  input: toOperationalEntityInput(source, uuidv4())
});
